module.exports = {"Description":"AI : CC2640","RedundantCharacters":" -","ValidationRegex":"^AI2640$","TestData":{"Valid":["AI2640","AI-2640"],"Invalid":["A2640","AI02640","AI-02640"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/AI.json
// module id = 4443
// module chunks = 11